import type { Camera } from '@sb/integrations/implementations/Camera/implementation/Camera';
import type { WristCamera } from '@sb/integrations/implementations/WristCamera/implementation/WristCamera';
import type { CameraIntegration } from '@sb/integrations/types/cameraTypes';

export async function getCameraColorFrame(
  cameraEquipment: Camera | WristCamera | undefined,
  cameraIntegration: CameraIntegration | undefined,
): Promise<ArrayBuffer> {
  if (cameraEquipment?.kind === 'WristCamera' && cameraIntegration) {
    return (cameraEquipment as WristCamera).getColorFrame(cameraIntegration);
  }

  if (cameraEquipment?.kind === 'Camera') {
    return (cameraEquipment as Camera).getColorFrame();
  }

  throw new Error('Missing camera equipment or camera integration');
}
